export default "//cloud.imgsmail.ru/cloud.mail.ru/184038/img/build/ask-phone-popup/success-phone.png";